document.addEventListener("DOMContentLoaded", function() {
    var customAppBlocks = document.querySelectorAll('.bikini-prodct .custom-app-block');
    
    customAppBlocks.forEach(function(block) {
        if (block.querySelector('.jdgm-widget')) {
            block.classList.add('judgeme-stars');
        }
    });
});


document.addEventListener("DOMContentLoaded", function() {
  // Function to create and insert the button
  function addButton() {
    // Create the button element
    var button = document.createElement("button");
    button.innerHTML = "Select Color and Size";
 button.className = "variant-show-btn";
    // Optionally, add some styling to the button
    // button.style.padding = "10px 20px";
    // button.style.fontSize = "16px";
    // button.style.cursor = "pointer";

    // Find the add to cart section div
    var addToCartSection = document.querySelector(".th_pb_addtocart_section.th_pb_wf");
 if (!addToCartSection) {
      console.warn("Add to Cart section not found.");
      return;
    }
    // Find the add to cart button within the add to cart section
    var addToCartButton = addToCartSection.querySelector(".th_pb_add_to_cart");

    // Insert the new button above the add to cart button
    if (addToCartSection && addToCartButton) {
      addToCartSection.insertBefore(button, addToCartButton);
    }

    // Add click event listener to the button
    button.addEventListener("click", function() {
      // Find all variants section divs
      var variantsSections = document.querySelectorAll(".th_pb_variants_section.th_pb_wf.th_pb_variants_section_layout_1");

      // Toggle the display property of all variants sections
      variantsSections.forEach(function(section) {
        section.style.display = section.style.display === "none" || section.style.display === "" ? "block" : "none";
      });
    });
  }

  // Delay the execution by 3 seconds
  setTimeout(addButton, 3000);
});







document.addEventListener("DOMContentLoaded", function() {
  // Function to split the text into spans
  function splitTextIntoSpans() {
    // Find the target div
    var targetDiv = document.querySelector("div#th_pb_all_bundles_list  .th_pb_title_description");

    if (targetDiv) {
      // Extract the text content
      var content = targetDiv.innerHTML;

      // Split the content at <br>
      var parts = content.split("<br>");

      // Create span elements for each part
      var spanBefore = document.createElement("span");
      var spanAfter = document.createElement("span");

      // Set the text for each span
      spanBefore.innerHTML = parts[0].trim();
      spanAfter.innerHTML = parts[1] ? parts[1].trim() : "";

      // Clear the target div
      targetDiv.innerHTML = "";

      // Append the spans to the target div
      targetDiv.appendChild(spanBefore);
      targetDiv.appendChild(document.createElement("br"));
      targetDiv.appendChild(spanAfter);
    }
  }

  // Run the function after a delay to ensure the content is fully loaded
  setTimeout(splitTextIntoSpans, 3000);
});
var $ = jQuery;
$(document).ready(function(){
   $('.wholesale-hero-module .btn').click(function(e){
      e.preventDefault();
      var target=$(this).attr("href");
      $("html, body").animate({
          scrollTop:$(target).offset().top - 60
      });
   });
});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.wholesale-hero-module .btn').forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            var target = this.getAttribute("href");
            var targetElement = document.querySelector(target);
            if (targetElement) {
                var offsetTop = targetElement.offsetTop - 60;
                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });
            }
        });
    });
});

